module.exports = ".pac-container {\r\n    z-index: 10000!important;\r\n}\r\n.pac-item {\r\n    cursor:pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/angular_library/components/google-place-autocomplete/google-place-autocomplete.css
// module id = ./src/angular_library/components/google-place-autocomplete/google-place-autocomplete.css
// module chunks = main